(function TaskLists($, Adzuki)
{
	"use strict";

	$(document).ready(function onReady()
	{
		Adzuki.onload(['TaskListTemplates/index'], function onload()
		{
			var $agent_templates     = $('#my-task-list-templates');
			var $franchise_templates = $('#franchise-task-list-templates');
			var $global_templates    = $('#global-task-list-templates');

			// agent task list templates
			Adzuki.Ajax.get('/TaskListTemplates/agentTemplates')
				.then(function populateAgentTemplates(response) {
					$agent_templates.html(response);
					Adzuki.TableSorter.initAjax($agent_templates);
				}
			);

			// franchise shared task list templates
			Adzuki.Ajax.get('/TaskListTemplates/franchiseTemplates')
				.then(function populateFranchiseTemplates(response) {
					$franchise_templates.html(response);
					$('.auto-toggle').off().on('click', _toggleAutoApply);
					Adzuki.TableSorter.initAjax($franchise_templates);
				}
			);

			// global task list templates
			Adzuki.Ajax.get('/TaskListTemplates/globalTemplates')
				.then(function populateGlobalTemplates(response) {
					$global_templates.html(response);
					Adzuki.TableSorter.initAjax($global_templates);
				}
			);

			// init table sort when navigating to a different page
			$('body').on('ajax-pagination.loaded', function onAjaxLoaded() {
				Adzuki.TableSorter.initAjax($agent_templates);
				Adzuki.TableSorter.initAjax($franchise_templates);
				Adzuki.TableSorter.initAjax($global_templates);
			});
		});
	});

	function _toggleAutoApply(e)
	{
		var $icon_elem        = $(this),
		    template_id       = $icon_elem.data('id'),
		    auto_apply_status = $icon_elem.data('status'),
		    success_message   = 'Auto apply has been turned OFF for the template',
		    toggle_url        = '/TaskListTemplates/toggleAutoApply/' + template_id + '/' + auto_apply_status;

		e.preventDefault();

		if (auto_apply_status === 1) {
			success_message = 'Auto apply has been turned ON for the template';
		}

		Adzuki.Ajax.get(toggle_url)
			.then(function statusToggled(response) {
				if (response.toggle_status === 'error') {
					// no bueno, display error message
					Adzuki.StatusMessage('error', response.status_message, 'Error');
				} else {
					// gucci, toggle icons
					if (auto_apply_status === 1) {
						$('.template-auto-off-' + template_id).addClass('hidden');
						$('.template-auto-on-' + template_id).removeClass('hidden');
					} else {
						$('.template-auto-on-' + template_id).addClass('hidden');
						$('.template-auto-off-' + template_id).removeClass('hidden');
					}

					// reload my templates tab
					Adzuki.Ajax.get('/TaskListTemplates/agentTemplates')
						.then(function populateAgentTemplates(tab_response) {
							$('#my-task-list-templates').html(tab_response);
						}
					);

					// display success message
					Adzuki.StatusMessage('success', success_message, 'Success');
				}
			});
	}
}(jQuery, window.Adzuki || {}));
